import React from 'react';
import ReactDOM from 'react-dom';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withLock, keyVault } from '@bingads-webui-react/popup-manager';
import { FluctuationPopup } from './fluctuation-popup';
import { instrumentationSchema } from './fluctuation-instr-schema';

export function createElementBasedFluctuationPopupFactory(props, placeholderElement) {
  const {
    onDismiss,
    triggerButton,
    deps,
    asyncLoadFluctuationConfig,
    fromScenario,
    metrics,
    getFluctuationPopupStyles,
  } = props;

  deps.instrumentation.addScenario(instrumentationSchema);
  const fluctuationScenario = deps.instrumentation.fluctuation.create();
  const activities = {
    userActionActivity: fluctuationScenario.userAction.create(),
  };

  const { context } = deps;
  /* istanbul ignore next */
  const calloutKey = `${context.CurrentAccount.Id} ${context.CurrentCampaign && context.CurrentCampaign.Id} ${asyncLoadFluctuationConfig && asyncLoadFluctuationConfig.fluctuationTypeIds}`;
  /* istanbul ignore next */
  const metricsObject = Array.isArray(metrics) && metrics.length ? metrics[0] : {};

  /* istanbul ignore next */
  if (!(triggerButton instanceof Element)) {
    throw new Error('TriggerButton is not an element.');
  }

  /* istanbul ignore next */
  const onOutsideClick = (e, srcTarget) => {
    if (e.target !== srcTarget) {
      if (onDismiss) {
        onDismiss();
      }

      ReactDOM.unmountComponentAtNode(placeholderElement);
      /* istanbul ignore next */
      activities.userActionActivity
        .trace(
          `Fluctuation popup closed. aid: ${context.CurrentAccount.Id}, campaignId: ${context.CurrentCampaign && context.CurrentCampaign.Id}, FromScenario: ${fromScenario}, MetricsName: ${metricsObject.name || undefined}, MetricsType: ${metricsObject.type || undefined}`,
          'FluctuationAction'
        );
    }
  };

  /* istanbul ignore next */
  activities.userActionActivity
    .trace(
      `Fluctuation popup opened. aid: ${context.CurrentAccount.Id}, campaignId: ${context.CurrentCampaign && context.CurrentCampaign.Id}, FromScenario: ${fromScenario}, MetricsName: ${metricsObject.name || undefined}, MetricsType: ${metricsObject.type || undefined}`,
      'FluctuationAction'
    );

  let fluctuationPopupElement = FluctuationPopup;

  if (getFluctuationPopupStyles) {
    fluctuationPopupElement = withDefaultStyles(FluctuationPopup, getFluctuationPopupStyles);
  }

  const fluctuationPopupElementWithLock = withLock(fluctuationPopupElement, {
    lockKey: keyVault.clickingPopup,
    force: true,
  });

  ReactDOM.render(
    React.createElement(fluctuationPopupElementWithLock, {
      ...props,
      onDismiss: onOutsideClick,
      isReactNodeTriggerButton: false,
      key: calloutKey,
    }),
    placeholderElement
  );
}
